<section>

    <article class="card container-fluid" style="max-width: 1200px">
        <h2 class="card-header text-center font-weight-bold text-uppercase py-4">Files for Property: {{property.address}}</h2>

        <!-- Header -->
        <article class="table-header">
          <!-- Toolbar -->
          <div class="toolbar">
            <!-- Back to List -->
            <a [routerLink]="['/courses/RentWise/properties']" class="pull-left">
                <button type="button" class="dt-button"><i class="fas fa-angle-left mr-2"></i> Back to List</button>
            </a>

            <!-- Add Files -->
            <button type="button" class="dt-button" (click)="addFilesDialog()">
                <span>Add Files</span>
                <mdb-icon class="text-success ml-1" fas icon="plus" size="md"></mdb-icon>
            </button>
          </div>
        </article>

        <!-- Table -->
        <div class="card-body" style="overflow-x:auto">
            <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table-striped stripe hover row-border order-column">
                <thead>
                    <tr>
                        <th>&nbsp;</th>
                        <th>File Name</th>
                        <th>File Type</th>
                        <th>File Size</th>
                        <th>Upload Date</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let file of files">
                        <td class="td-preview">
                            <a [href]="file.url" target="_blank">
                                <!-- <span *ngIf="file.mimetype?.startsWith('image')" class="file-preview image">
                                    <img [src]="file.url" />
                                </span> -->
                                <!-- <span *ngIf="!file.mimetype?.startsWith('image')" class="file-preview file-placeholder" -->
                                <span class="file-preview file-placeholder"
                                    [ngClass]="[(file.mimetype.split('/')[0] || 'unknown') + '-type']">
                                    <span *ngIf="file.ext" class="ext">{{file.ext.substr(0, 3) | uppercase}}</span>
                                    <mdb-icon far icon="file"></mdb-icon>
                                </span>
                            </a>
                        </td>
                        <td class="td-filename">{{ file.filename }}</td>
                        <td>{{ file.ext | uppercase }}</td>
                        <td [attr.data-sort]="file.size.toFixed(10)">{{ file.size | filesize }}</td>
                        <td class="text-nowrap" [attr.data-sort]="sortDate(file.uploaded)">{{ file.uploaded | date }}</td>
                        <td class="td-actions">
                            <!-- View -->
                            <a [href]="file.url" target="_blank" class="mr-2">
                                <button type="button"><mdb-icon fas icon="eye"></mdb-icon></button>
                            </a>

                            <!-- Delete -->
                            <button type="button" class="mr-2 btn-danger" (click)="deleteFile(file)"><mdb-icon fas icon="trash"></mdb-icon></button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </article>
</section>
